import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";
import CartListProduct from "./CartListProduct";
import WishlistProduct from "./WishlistProduct";
import {Link} from "react-router-dom";

const CartProduct = () => {
    return (
        <div className="cart-product-wrapper">
            <div className="cart-link-products">
                <ul className="nav nav-tabs xmb-6" id="tabCart" role="tablist">
                    <li className="nav-item" role="presentation">
                        <a href="#" className="nav-link active" id="nav-cart-tab"
                           data-bs-toggle="tab"
                           data-bs-target="#nav-cart" role="tab"
                           aria-controls="nav-cart" aria-selected="true">
                            <IconName name="cart" className="icon"/>
                            سبد خرید
                            <div className="badge-number-cart persian-number"><span>4</span></div>
                        </a>
                    </li>
                    <li className="nav-item" role="presentation">
                        <a href="#" className="nav-link" id="nav-tag-cart-tab"
                           data-bs-toggle="tab"
                           data-bs-target="#nav-tag-cart" role="tab"
                           aria-controls="nav-tag-cart" aria-selected="true">
                            <IconName name="favorite_border" className="icon"/>
                            نشان‌شده‌ها
                            <div className="badge-number-cart persian-number"><span>2</span></div>
                        </a>
                    </li>
                </ul>
                <div className="content-links-cart-page xmb-25">
                    <div className="tab-content" id="nav-tab-content">
                        <div className="links-cart tab-pane fade show active" id="nav-cart"
                             role="tabpanel" aria-labelledby="nav-cart-tab">
                            <div className="cart-list-product xmt-2">
                                <CartListProduct/>
                                {/*<EmptyCartList/>*/}
                            </div>
                            <div className="step-buy-cart-page position-fixed">
                                <div className="container d-flex justify-content-between align-items-center">
                                    <div className="prev-button">
                                        <span className="text">قبلی</span>
                                    </div>
                                    <div className="step-buy">
                                        <ul className="nav persian-number">
                                            <li className="nav-item active">
                                                <a href="#">
                                                    <div className="step"><span>1</span></div>
                                                    <div
                                                        className="text">سبد خرید
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a href="#">
                                                    <div className="step"><span>2</span></div>
                                                    <div
                                                        className="text">تکمیل اطلاعات
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a href="#">
                                                    <div className="step"><span>3</span></div>
                                                    <div
                                                        className="text">شیوه‌ی ارسال
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a href="#">
                                                    <div className="step"><span>4</span></div>
                                                    <div
                                                        className="text">تایید نهایی
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="button-next">
                                        <Link to="/infoUser">
                                            <span className="text">۱۵،۷۸۵،۰۰۰ ت</span>
                                            <IconName name="chevron_left" className="icon"/>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="links-tag-cart tab-pane fade show" id="nav-tag-cart"
                             role="tabpanel" aria-labelledby="nav-tag-cart-tab">
                            <div className="wishlist xmt-2">
                                <WishlistProduct/>
                                {/*<EmptyTagCart/>*/}
                            </div>
                            <div className="step-buy-cart-page position-fixed">
                                <div className="container d-flex justify-content-between align-items-center">
                                    <div className="prev-button">
                                        <span className="text">قبلی</span>
                                    </div>
                                    <div className="step-buy">
                                        <ul className="nav persian-number">
                                            <li className="nav-item active">
                                                <a href="#">
                                                    <div className="step"><span>1</span></div>
                                                    <div
                                                        className="text">سبد خرید
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a href="#">
                                                    <div className="step"><span>2</span></div>
                                                    <div
                                                        className="text">تکمیل اطلاعات
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a href="#">
                                                    <div className="step"><span>3</span></div>
                                                    <div
                                                        className="text">شیوه‌ی ارسال
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a href="#">
                                                    <div className="step"><span>4</span></div>
                                                    <div
                                                        className="text">تایید نهایی
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="button-next add-all-cart">
                                        <a href="#" id="add-all-cart">
                                            <IconName name="add_shopping_cart" className="icon"/>
                                            <span className="text">افزودن همه به سبد خرید</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartProduct;
